export enum BasicVarnishActionsTypes {
  GET = "@@BASIC_VARNISH fetch basicVarnish",
  GET_STATUS = "@@BASIC_VARNISH fetch status basicVarnish",
  CREATE = "@@BASIC_VARNISH add basicVarnish",
  CREATE_STATUS = "@@BASIC_VARNISH add status basicVarnish",
  PATCH_ONE = "@@BASIC_VARNISH patch basicVarnish",
  PATCH_STATUS = "@@BASIC_VARNISH patch status basicVarnish"
}
